import type { ApiError, Fetcher } from '@fuze/portal-core';

let fetcher: Fetcher | undefined;

/** Called once at boot (App.tsx) with the fetcher built from runtime config. Tests call it in their setup. */
export const configureApiClient = (configured: Fetcher): void => {
  fetcher = configured;
};

/**
 * orval's mutator: every generated hook calls this with a path and RequestInit. It delegates to portal-core's fetcher
 * so cookies, X-Request-Id, the CSRF header and ApiError apply to every operation without the generator knowing.
 */
export const apiFetch = <T>(path: string, init?: RequestInit): Promise<T> => {
  if (fetcher === undefined) {
    throw new Error('API client used before configureApiClient(); App.tsx configures it at boot.');
  }
  return fetcher<T>(path, init);
};

/** What generated hooks reject with: the fetcher turns every non-2xx into an ApiError (body included as `body`). */
export type ErrorType<_ResponseBody> = ApiError;
